import "./Shop.module.css";
import Header from "@/reusable_sections/Header";
import Shop from "./sections/Shop";
import Catalog from "./sections/Catalog";
import Footer from "@/reusable_sections/Footer";
export default function ShopPage() {
  return <div>
      <Header />
      <Shop />
      <Catalog />
      <Footer />
    </div>;
}